import { Component, OnDestroy, OnInit, ViewChild, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute } from '@angular/router';
import { UIBlockerService } from '@howdeniberia/core-front';
import { tap } from 'rxjs';
import { IMapService } from 'src/app/core/services/api/map';
import { IRisksDataMapService } from 'src/app/core/services/core';
import { HelpRiskMapComponent } from 'src/app/features/help/dialogs/help-risk-map/help-risk-map.component';
import { SubSink } from 'subsink';
import { DownloadReportComponent } from '../../dialogs/pages/download-report/download-report.component';
import { RisksMapComponent } from '../risks-map/risks-map.component';
import { RisksSelectionComponent } from '../risks-selection/risks-selection.component';
import { RisksStepsComponent } from '../risks-steps/risks-steps.component';

@Component({
  selector: 'howden-risks-evaluation',
  templateUrl: './risks-evaluation.component.html',
  styleUrls: ['./risks-evaluation.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatButton,
    MatIcon,
    MatIconButton,
    MatTabsModule,
    RisksStepsComponent,
    RisksSelectionComponent,
    RisksMapComponent
  ]
})
export class RisksEvaluationComponent implements OnInit, OnDestroy {
  private activatedRoute = inject(ActivatedRoute);
  private dialog = inject(MatDialog);
  private dataRiskMapSrv = inject(IRisksDataMapService);
  private uiBlockerSrv = inject(UIBlockerService);
  private mapSrv = inject(IMapService);

  @ViewChild(RisksStepsComponent, { static: true }) childSteps!: RisksStepsComponent;

  private _subscriptions = new SubSink();

  ngOnInit() {
    this._subscriptions.sink = this.activatedRoute.paramMap.pipe(
      tap(paramMap => {
        this.uiBlockerSrv.block();

        const id = paramMap.get('id') as string;

        if (typeof id !== 'undefined' && id !== null) {
          this.childSteps.loadSteps(id);
        } else {
          // Abrimos la ayuda del mapa
          this.helpRiskMap(true);
        }
      })
    ).subscribe();
  }

  ngOnDestroy() {
    this._subscriptions.unsubscribe();
  }

  helpRiskMap(isOnInit: boolean) {
    const dialogRef = this.dialog.open(HelpRiskMapComponent, {
      height: '95%',
      width: '95%',
      maxHeight: '100vw !important',
      maxWidth: '100vw !important'
    });

    if (isOnInit) {
      this._subscriptions.sink = dialogRef.afterClosed().subscribe(() => {
        this.childSteps.loadSteps(null);
      });
    }
  }

  get newData() {
    return this.dataRiskMapSrv.canSaveMap();
  }

  saveMapData() {
    this.uiBlockerSrv.block();

    this.mapSrv.save(this.dataRiskMapSrv.getDataRiskMap(null)).subscribe((response) => {
      const mapId = response.result as number;
      this.dataRiskMapSrv.setMapId(mapId);
      this.dataRiskMapSrv.setAlreadySaved(true);
      this.uiBlockerSrv.unblock();
    });
  }

  downloadRiskReport() {
    const element = document.getElementById('divGraphMap');
    this.dataRiskMapSrv.generateMapImage(element);

    this.dialog.open(DownloadReportComponent, {
      width: '1000px'
    });
  }
}
